import { project, pathologies } from "./constants";

const renderOptions = (options, t) => {
  return options.map((option) => (
    <option key={option.value} value={option.value}>
      {t(option.label)}
    </option>
  ));
};

export const renderCivilStatusOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
    { value: "Widowed", label: "Widowed" },
    { value: "Single", label: "Single" },
  ];

  return renderOptions(options, t);
};

export const renderEducationOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Primary", label: "Primary" },
    { value: "Secondary", label: "Secondary" },
    { value: "University", label: "University" },
    { value: "Postgraduate", label: "Postgraduate" },
    { value: "Other", label: "Other" },
    { value: "None", label: "None" },
  ];

  return renderOptions(options, t);
};

export const renderWorkOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Employed", label: "Employed" },
    { value: "Unemployed", label: "Unemployed" },
    { value: "Retired", label: "Retired" },
    { value: "Student", label: "Student" },
    { value: "Other", label: "Other" },
  ];

  return renderOptions(options, t);
};

export const renderAffectationsOptions = (t) => {
  const options = {
    global: [
      { value: "", label: "" },
      { value: pathologies.otherId, label: "patientPathology_other" },
      { value: pathologies.alzheimerId, label: "patientPathology_alzheimer" },
      { value: pathologies.ataxiaId, label: "patientPathology_ataxia" },
      { value: pathologies.cerebralPalsyId, label: "patientPathology_cerebralPalsy" },
      { value: pathologies.multipleSclerosisId, label: "patientPathology_multipleSclerosis" },
      { value: pathologies.parkinsonId, label: "patientPathology_parkinson" },
      { value: pathologies.spinalCordInjuryId, label: "patientPathology_spinalCordInjury" },
      { value: pathologies.strokeId, label: "patientPathology_stroke" },
      { value: pathologies.traumaticBrainInjuryId, label: "patientPathology_traumaticBrainInjury" },
    ],
    strack: [{ value: pathologies.strokeId, label: "patientPathology_stroke" }],
  };

  const selectedOptions = options[project] || [];

  return renderOptions(selectedOptions, t);
};

export const renderStrokeSideOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Left", label: "Left" },
    { value: "Right", label: "Right" },
    { value: "Both", label: "Both" },
  ];

  return renderOptions(options, t);
};

export const renderStrokeTypeOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Ischemic", label: "Ischemic" },
    { value: "Hemorrhagic", label: "Hemorrhagic" },
    { value: "Lacunar", label: "Lacunar" },
    { value: "Other", label: "Other" },
  ];

  return renderOptions(options, t);
};

export const renderStrokeLocationOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Anterior Cerebral Artery (ACA)", label: "Anterior Cerebral Artery (ACA)" },
    { value: "Middle Cerebral Artery (MCA)", label: "Middle Cerebral Artery (MCA)" },
    { value: "Posterior Cerebral Artery (PCA)", label: "Posterior Cerebral Artery (PCA)" },
    { value: "Subcortical", label: "Subcortical" },
  ];

  return renderOptions(options, t);
};

export const renderPareticSidesOptions = (t) => {
  const options = {
    global: [
      { value: "LEFT", label: "pathologyInformation_pareticSideSelect_left" },
      { value: "RIGHT", label: "pathologyInformation_pareticSideSelect_right" },
    ],
    strack: [
      { value: "LEFT", label: "pathologyInformation_pareticSideSelect_left" },
      { value: "RIGHT", label: "pathologyInformation_pareticSideSelect_right" },
      { value: "BILATERAL", label: "pathologyInformation_pareticSideSelect_bilateral" },
      { value: "VERTEBROBASILAR", label: "pathologyInformation_pareticSideSelect_vertebrobasilar" },
      { value: "UNDETERMINED", label: "pathologyInformation_pareticSideSelect_undetermined" },
    ],
  };
  const selectedOptions = options[project] || [];

  return renderOptions(selectedOptions, t);
};

export const renderComorbidityOptions = (t) => {
  const options = [
    { value: "", label: "" },
    { value: "Diabetes", label: "Diabetes" },
    { value: "Hypertension", label: "Hypertension" },
    { value: "Cardiopathy", label: "Cardiopathy" },
    { value: "Obesity", label: "Obesity" },
    { value: "Other", label: "Other" },
    { value: "None", label: "None" },
  ];

  return renderOptions(options, t);
};
